<template>
    <div class="max-w-screen-xl mx-auto mt-12 md:mt-18 lg:mt-20 xl:mt-24 md:mb-8 mb-6 px-4">

        <h2 class="text-2xl sm:text-3xl font-semibold mb-6 sm:mb-10" v-html="dataLocales.any_content.title">

        </h2>
        <div class="grid grid-cols-12 lg:gap-8">
            <div class="lg:col-span-7 col-span-12">
                <div class="mb-6" v-for="post in dataLocales.data">
                    <h3 class="text-xl sm:text-2xl font-semibold mb-3"> {{ post.title }}</h3>
                    <div class="text-base lg:text-lg" v-html="post.description">

                    </div>
                </div>

                <div class="mt-4">
                    <a href="https://app.qrgateway.com/page-builder" target="_blank" rel="nofollow"
                        class="flex items-center gap-2 h-[50px] px-8 w-fit rounded-3xl bg-success text-white drop-shadow-md hover:drop-shadow-xl">{{
                            $t('try_page_editor') }}</a>
                </div>
            </div>
            <div class="lg:col-span-5 lg:block hidden">
                <nuxt-img loading="lazy" src="/media.png" height="380px" alt="multimedia-to-qrcode" format="webp" />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import MultiDataLocale from '~~/config/interface/MultiDataLocale';


const dataLocales = new MultiDataLocale([
    {
        locale: "en",
        title: "📸 <span class='text-success'>Scan Qr Code</span> to play audio and video",
        data: [
            {
                title: "Click to play, fast loading, no ads, no watermarks. ",
                description: " <p>Scan the code to play and save a lot of CD costs, improving learning and work efficiency.</p> <p>Ad-free playback, no buffering, video without watermarks, ensuring a smooth viewing experience.</p> <p>Suitable for various scenarios such as student teaching, multimedia books, and scenic area introductions.</p>"
            }
        ]
    },
    {
        locale: "vi",
        title: "📸 <span class='text-success'>Quét mã QR</span> để phát âm thanh và video",
        data: [
            {
                title: "Bấm để phát, tải nhanh, không có quảng cáo, không có logo.",
                description: " <p>Quét mã để phát và tiết kiệm chi phí đĩa CD, tăng cường hiệu quả học tập và làm việc.</p> <p>Phát lại không có quảng cáo, không có đệm, video không có logo, đảm bảo trải nghiệm xem mượt mà.</p> <p>Phù hợp cho nhiều tình huống như giảng dạy sinh viên, sách đa phương tiện và giới thiệu vùng địa lý.</p>"
            }
        ]
    }
    ,
    {
        locale: "de",
        title: "📸 <span class='text-success'>QR-Code scannen</span> zum Abspielen von Audio und Video",
        data: [
            {
                title: "Klicken Sie, um abzuspielen, schnelles Laden, keine Anzeigen, keine Wasserzeichen. ",
                description: " <p>Scannen Sie den Code, um abzuspielen und sparen Sie eine Menge CD-Kosten, verbessern Sie die Lern- und Arbeitsleistung.</p> <p>Werbefreies Abspielen, kein Puffern, Video ohne Wasserzeichen, für eine reibungslose Betrachtungserfahrung.</p> <p>Geeignet für verschiedene Szenarien wie Studentenunterricht, Multimedia-Bücher und Vorstellung von Landschaften.</p>"
            }
        ]
    },
    {
        locale: "it",
        title: "📸 <span class='text-success'>Scansiona il codice QR</span> per riprodurre audio e video",
        data: [
            {
                title: "Clicca per riprodurre, caricamento veloce, senza pubblicità, senza filigrane.",
                description: " <p>Scansiona il codice per riprodurre e risparmiare sui costi dei CD, migliorando l'efficienza di apprendimento e lavoro.</p> <p>Riproduzione senza pubblicità, senza buffering, video senza filigrane, garantendo un'esperienza di visione fluida.</p> <p>Adatto a vari scenari come l'insegnamento degli studenti, i libri multimediali e le presentazioni delle zone paesaggistiche.</p>"
            }
        ]
    },
    {
        locale: "fr",
        title: "📸 <span class='text-success'>Scanner le code QR</span> pour lire l'audio et la vidéo",
        data: [
            {
                title: "Cliquez pour lire, chargement rapide, pas de publicités, pas de filigranes.",
                description: " <p>Scannez le code pour lire et économiser sur les coûts de CD, améliorant l'efficacité d'apprentissage et de travail.</p> <p>Lecture sans publicités, sans mise en mémoire tampon, vidéo sans filigranes, assurant une expérience de visionnage fluide.</p> <p>Convient à divers scénarios tels que l'enseignement aux étudiants, les livres multimédias et les présentations de zones paysagères.</p>"
            }
        ]
    },
    {
        locale: "nl",
        title: "📸 <span class='text-success'>Scan de QR-code</span> om audio en video af te spelen",
        data: [
            {
                title: "Klik om af te spelen, snel laden, geen advertenties, geen watermerken.",
                description: " <p>Scan de code om af te spelen en bespaar op de kosten van CD's, verbeter de efficiëntie van leren en werken.</p> <p>Afspelen zonder advertenties, zonder bufferen, video zonder watermerken, waardoor een soepele kijkervaring wordt gegarandeerd.</p> <p>Geschikt voor verschillende scenario's zoals het onderwijzen van studenten, multimedia-boeken en het introduceren van landschapsgebieden.</p>"
            }
        ]
    },
    {
        locale: "pt",
        title: "📸 <span class='text-success'>Escanear código QR</span> para reproduzir áudio e vídeo",
        data: [
            {
                title: "Clique para reproduzir, carregamento rápido, sem anúncios, sem marcas d'água.",
                description: " <p>Escanear o código para reproduzir e economizar nos custos de CDs, melhorando a eficiência de aprendizado e trabalho.</p> <p>Reprodução sem anúncios, sem buffer, vídeo sem marcas d'água, garantindo uma experiência de visualização suave.</p> <p>Adequado para vários cenários, como ensino de estudantes, livros multimídia e apresentações de áreas paisagísticas.</p>"
            }
        ]
    },
    {
        locale: "zh",
        title: "📸 <span class='text-success'>扫描二维码</span> 播放音频和视频",
        data: [
            {
                title: "点击播放，快速加载，无广告，无水印。",
                description: " <p>扫描二维码以播放和节省 CD 成本，提高学习和工作效率。</p> <p>无广告播放，无缓冲，视频无水印，确保流畅的观看体验。</p> <p>适用于各种场景，如学生教学、多媒体书籍和景区介绍。</p>"
            }
        ]
    },
    {
        locale: "ja",
        title: "📸 <span class='text-success'>QRコードをスキャン</span> して音声とビデオを再生する",
        data: [
            {
                title: "再生するにはクリック、高速ロード、広告なし、透かしなし。",
                description: " <p>コードをスキャンして再生し、CD のコストを節約し、学習と仕事の効率を向上させます。</p> <p>広告なしの再生、バッファリングなし、透かしのないビデオにより、スムーズな視聴体験が保証されます。</p> <p>学生の教育、マルチメディアブック、景色の紹介など、さまざまなシナリオに適しています。</p>"
            }
        ]
    },
    {
        locale: "es",
        title: "📸 <span class='text-success'>Escanea el código QR</span> para reproducir audio y video",
        data: [
            {
                title: "Haz clic para reproducir, carga rápida, sin anuncios, sin marcas de agua.",
                description: " <p>Escanea el código para reproducir y ahorrar en costos de CD, mejorando la eficiencia de aprendizaje y trabajo.</p> <p>Reproducción sin anuncios, sin buffering, video sin marcas de agua, garantizando una experiencia de visualización suave.</p> <p>Adecuado para diversos escenarios como la enseñanza de estudiantes, libros multimedia y presentaciones de áreas escénicas.</p>"
            }
        ]
    }
])

</script>